<!-- Topbar Start -->
<div class="custom-navbar navbar-custom topnav-navbar">
  <div class="topbar-container">
    <ul class="list-unstyled topbar-right-menu w-100 mb-0 justify-content-end align-items-center d-flex">
      @if (topbarItem?.hasSearchBar || topbarItem?.searchBarReplaceTitle) {
        <li class="me-auto">
          @if (topbarItem?.hasSearchBar ) {
            <app-search-bar [placeholder]="topbarItem?.searchPlaceholder"></app-search-bar>
          }
          @if (topbarItem?.searchBarReplaceTitle ) {
            <h2 class="page-title">{{topbarItem?.searchBarReplaceTitle }}</h2>
          }
        </li>
      }
      @if (topbarItem?.hasViewToggle && (filterService?.getFilterLoaded() | async) === true) {
        <li>
          <app-view-toggle
            [config]="viewToggleConfig"
            (selectedKeyChange)="onViewChange($event)">
          </app-view-toggle>
        </li>
      }
      @if (topbarItem?.hasHidePhiButton) {
        <li class="hide-phi-container">
          <div class="me-2 ms-0 text-center d-flex align-items-center">
            <input type="checkbox"  [(ngModel)]="isPhiHidden" (ngModelChange)="togglePHI()" data-switch="bool" id="isPhiHidden" />
            <label class="mb-0 mx-2" for="isPhiHidden" data-off-label="No" data-On-label="Yes">PHI</label>
          </div>
        </li>
      }
      @if (topbarItem?.hasNotificationList) {
        <li class="dropdown notification-list d-none" ngbDropdown>
          <a class="nav-link dropdown-toggle arrow-none" data-bs-toggle="dropdown" href="javascript: void(0);" role="button"
            aria-haspopup="false" aria-expanded="false" ngbDropdownToggle id="notificationDropdown">
            <i class="dripicons-bell noti-icon"></i>
          </a>
          <div class="dropdown-menu notification-dropdown" aria-labelledby="notificationDropdown" ngbDropdownMenu>
            <!-- item-->
            <div class="dropdown-item noti-title" ngbDropdownItem>
              <h5 class="m-0">Notification
              </h5>
            </div>
            <ngx-simplebar style="height: 240px;">
              <div id="notification-items">
                <!-- item-->
                @for (notification of notificationItems; track notification) {
                  <a href="{{ notification.redirectTo }}"
                    class="dropdown-item notify-item" ngbDropdownItem>
                    <div class="notify-icon bg-{{ notification.bgColor }}">
                      <i class="{{ notification.icon }}"></i>
                    </div>
                    <p class="notify-details">{{ notification.text }}
                      <small class="text-muted">{{ notification.subText }}</small>
                    </p>
                  </a>
                }
              </div>
            </ngx-simplebar>
          </div>
        </li>
      }

      @if (topbarItem?.hasUserProfileSection) {
        <li #statusDropdown="ngbDropdown" ngbDropdown [autoClose]="'outside'"
          class="profile-container ms-2 dropdown" (openChange)="dropdownOpen = $event">
          <button type="button" class="dark-mode-avatar cursor-pointer border-0 bg-transparent p-0" (click)="toggleTheme()" aria-label="Toggle theme">
            <img [src]="(userPreferenceService.isDarkTheme$ | async) ? 'assets/icons/dark-moon.svg' : 'assets/icons/light-moon.svg'" class="menu-icon" alt="Theme toggle">
          </button>
          <a class="nav-link dropdown-toggle arrow-none profile-dropdown ms-0 me-0" data-bs-toggle="dropdown"
            href="javascript: void(0);" role="button" aria-haspopup="false" aria-expanded="false" ngbDropdownToggle
            id="profileDropdown">
            @switch (userService.USER_PROFILE?.gender?.toLowerCase()) {
              @case ('female') {
                <span class="doctor-avatar doctor-avatar-bg">
                  <img src="/assets/icons/doctor-avatar.svg" alt="Doctor Avatar" class="img-fluid">
                </span>
              }
              @default {
                <span class="doctor-avatar">
                  <img src="/assets/icons/doctor-avatar-male.png" alt="Doctor Avatar" class="img-fluid">
                </span>
              }
            }
            <span class="arrow">
              @if (!dropdownOpen) {
                <img [src]="(userPreferenceService.isDarkTheme$ | async) ? 'assets/icons/dark-caret-down.svg' : 'assets/icons/light-caret-down.svg'" alt="Arrow Down" class="img-fluid">
              }
              @if (dropdownOpen) {
                <img [src]="(userPreferenceService.isDarkTheme$ | async) ? 'assets/icons/dark-caret-down.svg' : 'assets/icons/light-caret-down.svg'" alt="Arrow Up" class="img-fluid up-arrow">
              }
            </span>
          </a>
          <div class="dropdown-menu dropdown-menu-right topbar-dropdown-menu" ngbDropdownMenu>
            <a href="javascript:void(0);" class="dropdown-item notify-item d-flex" ngbDropdownItem (click)="logout()">
              <img src="/assets/icons/logout.svg" alt="Logout Icon" class="img-fluid me-1">
              <span>Logout</span>
            </a>
          </div>
        </li>
      }

    </ul>

  </div>
</div>
<!-- end Topbar -->